import { NgModule } from '@angular/core';
import { OpenTelemetryBootstrapModule } from '@lentau/core/open-telemetry/shared/open-telemetry.bootstrap';
import { AddressMercuryStoreModule } from '@lentau/address/mercury/store/address-mercury.module';

@NgModule({
  imports: [AddressMercuryStoreModule, OpenTelemetryBootstrapModule],
})
export class AppCoreModule {}
